module.exports = __webpack_public_path__ + "static/media/digital-1.b4ed1ee5.png";